__turbopack_context__.v({
  "cta": "register-module-scss-module__pFiWYW__cta",
  "heading": "register-module-scss-module__pFiWYW__heading",
  "registerContainer": "register-module-scss-module__pFiWYW__registerContainer",
});
